"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalState = void 0;

var _react = require("react");

var useModalState = function useModalState() {
  var _ref = (0, _react.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      open = _ref2[0],
      setOpen = _ref2[1];

  var openModal = function openModal() {
    setOpen(true);
  };

  var closeModal = function closeModal() {
    setOpen(false);
  };

  return {
    open: open,
    openModal: openModal,
    closeModal: closeModal
  };
};

exports.useModalState = useModalState;